import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgSelectModule } from '@ng-select/ng-select';

import { NgbNavModule, NgbAccordionModule, NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';

import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // ---------------------------------------------------------------------
    // Root-level DI for modal content.
    //
    // NgbModal renders content outside the lazy route's view: component
    // content gets `environmentInjector: applicationRef.injector` hardcoded,
    // and TemplateRef content is attached via `applicationRef.attachView()`.
    // Either way, module-scoped providers from the lazy ProductsModule are
    // not in the lookup chain, so anything the add/edit-country modal tree
    // injects has to be resolvable from the ROOT injector.
    //
    // These four modules are the only ones ProductsModule imports that
    // declare module-scoped providers:
    //   ReactiveFormsModule -> FormBuilder, UntypedFormBuilder,
    //                          NonNullableFormBuilder (providedIn the module,
    //                          NOT 'root', as of Angular 15)
    //   FormsModule         -> RadioControlRegistry
    //   NgSelectModule      -> SELECTION_MODEL_FACTORY
    //   DragDropModule      -> DragDrop
    // Everything else it imports (NgbNav/Pagination/Datepicker/Modal,
    // CKEditorModule, NgWizardModule) declares none.
    //
    // AppModule used to import ProductsModule outright, which achieved the
    // same thing by accident while defeating lazy loading.
    // ---------------------------------------------------------------------
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    DragDropModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    LayoutsModule,
    AppRoutingModule,
    CarouselModule,
    ToastrModule.forRoot({
      preventDuplicates: true
    }),
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
    NgbModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],

})
export class AppModule { }
